// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"LD-z","smallCardRow":"MD-z","largeCardRow":"ND-z","productSearchRow":"OD-z","curatedRow":"PD-z"};